import styled from '@emotion/styled';

export const PlatformBadgeContent = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
`;

export const PlatformBadgeIconContainer = styled.div`
  width: 18px;
`;

export const PlatformBadgeLabel = styled.div`
  margin-left: 10px;
  color: #ffffff;
  font-weight: normal;
  font-size: 1rem;
  font-style: normal;
`;
